<div class="pagination-box">
    <!-- <div class="pagination-dropdown-box"> -->
    <!-- <p class="me-2">Showing </p> -->
    <!-- <mat-form-field appearance="outline" class="pagination-dropdown">
            <mat-select [(ngModel)]="pagination.pageSize" (ngModelChange)="onPageSizeChange()">
                <mat-option *ngFor="let size of pagination.pageSizes" [value]="size">
                    {{size}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <span class="ms-2">of {{pagination.length}} entries</span> -->
    <!-- </div> -->
    <div class="spacer"></div>
    <p-paginator
        (onPageChange)="onPageChange($event)"
        [rows]="pagination.pageSize"
        [totalRecords]="pagination.length"
        [showFirstLastIcon]="true"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="isRecordsPerPageDropdownEnable ? pagination.pageSizes : undefined"
        [first]="pagination.pageIndex * pagination.pageSize"
        currentPageReportTemplate="{first} - {last} of {totalRecords} entries"
    >
    </p-paginator>
    <!-- <ng-template #customTemplate>
        <button class="p-ripple p-element p-paginator-next p-paginator-element p-link">>>></button>
    </ng-template> -->
</div>
